import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiTextInput } from '@splashthat/sui';

import { getFormNode } from 'common/entities/formNode/selectors';
import { updateFormNodeValue } from '../../../actions/nodeActions';
import disableWhenLocked from './disableWhenLocked';

/**
 * The view to edit label for a question.
 */
const LabelControl = ({ inputLabel, label, onChange, disabled }) => (
    <SuiTextInput
        fullWidth
        label={inputLabel}
        value={label}
        disabled={disabled}
        onChange={(event, value) => onChange(value)}
    />
);

LabelControl.propTypes = {
    inputLabel: PropTypes.string.isRequired,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

LabelControl.defaultProps = {
    label: '',
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        label: props.formNodeId ? formNode.label : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (label) => dispatch(updateFormNodeValue(ownProps.formNodeId, 'label', label)),
});

const ConnectedLabelControl = connect(mapStateToProps, mapDispatchToProps)(disableWhenLocked(LabelControl));

ConnectedLabelControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedLabelControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedLabelControl;
